export default __webpack_public_path__ + "static/media/gallery09.e7e2890b.jpg";